import { render } from "./SiteHeader.vue?vue&type=template&id=f96e19fa&scoped=true&ts=true"
import script from "./SiteHeader.vue?vue&type=script&lang=ts"
export * from "./SiteHeader.vue?vue&type=script&lang=ts"

import "./SiteHeader.vue?vue&type=style&index=0&id=f96e19fa&scoped=true&lang=scss"

import exportComponent from "/home/christmasatourhouse-com/www/tickets/releases/202610123691/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96e19fa"]])

export default __exports__